export default {
  resolve(grade) {
    switch (grade) {
      case -1:
        return 'Pre-Kindergarten'
      case 0:
        return 'Kindergarten'
      case 1:
        return 'Grade 1'
      case 2:
        return 'Grade 2'
      case 3:
        return 'Grade 3'
      case 4:
        return 'Grade 4'
      case 5:
        return 'Grade 5'
      case 6:
        return 'Grade 6'
      case 7:
        return 'Grade 7'
      case 8:
        return 'Grade 8'
      case 9:
        return 'Grade 9'
      case 10:
        return 'Grade 10'
      case 11:
        return 'Grade 11'
      case 12:
        return 'Grade 12'
      case 13:
        return 'Post-Secondary'
      default:
        throw Error
    }
  }
}
